<template>
	<div class="login-elements-wrapper">
		<div class="background"></div>
		<div class="login-elements">
			<div class="margin-bottom">
				<MaterialText data-testid="email" :disabled="saving" v-model="email" v-on:enter="login()" label="Email" />
			</div>
			<div class="margin-bottom flex">
				<MaterialText data-testid="password"  :disabled="saving" :password="true" v-model="password" v-on:enter="login()" label="Password" :width="112" />
				<MaterialText data-testid="2fa"  :disabled="saving" v-model="challenge" v-on:enter="login()" label="2FA challenge" :width="112" class="small-margin-left" />
			</div>

			<button data-testid="login_btn"  :disabled="saving" v-on:click="login()">Sign in</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    saving: false,
    email: '',
    password: '',
    show_welcome: false,
    challenge: ''
  }),
  computed: {
    ...mapGetters([
      'getToken',
      'getStylist'
    ])
  },
  methods: {
    login () {
      Vue.$api.post('/stylist/login', {
        email: this.email,
        password: this.password,
        challenge: this.challenge
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.success(data)
      })
    },
    success (data) {
      this.$store.commit('setToken', data.token)
      this.$store.commit('setUserRoles', data.user_roles)
      this.$store.commit('setTestStylist', data.test_stylist)
      this.$store.commit('setStylist', {
        id: data.id,
        first_name: data.first_name,
        locale_id: data.locale_id,
        color: data.color,
        firmafon_token: data.firmafon_token
      })

      this.show_welcome = true

      this.$store.dispatch('loadRepositories')

      if (data.user_roles.length == 1 && data.user_roles.indexOf('stylist') >= 0) {
                	this.$router.push('/scheduled-calls/stylist')
      }
    }
  }
}
</script>
